module.exports = __webpack_public_path__ + "img/package-with-timer.04db894.svg";